import { IAppHookPayload } from './saveAppHook';
import { RequestAction } from '@redux-requests/core';
import { gql } from '@redux-requests/graphql';
import { AppsConstants } from './../constants';

export const deleteAppHook = (hookId: string, appId: string): RequestAction => ({
  type: AppsConstants.APP_DELETE_HOOK,
  request: {
    query: gql`
      mutation($id: ID!) {
        deleteAppHook(id: $id)
      }
    `,
    variables: { id: hookId },
  },
  meta: {
    mutations: {
      [AppsConstants.APP + appId]: (data, { deleteAppHook }) =>
        deleteAppHook
          ? { ...data, hooks: data.hooks.filter((hook: IAppHookPayload) => hook.id !== hookId) }
          : data,
    },
  },
});
